// import { TextEditorComponent } from '../../../custom-components/cell-editor/text-editor.component';

export let settingsPowerCatalogElementType = {
    noDataMessage: 'No existen tipos de poderes registrados',
    mode: 'inline',
    pager: {
      display: true,
      perPage: 1000
    },
    actions: {
      columnTitle: 'Opciones',
      position: 'right',
      add: true,
      edit: true,
      delete: true
    },
    columns: {
      // id: {
      //   title: 'Id',
      //   width: '100px',
      //   editable: false,
      //   filter: true
      // },
      name: {
        title: 'Tipo',
        width: '800px',
        editable: true,
        filter: true
      },
      description: {
        title: 'Descripcion',
        width: '800px',
        editable: true,
        filter: true
      }
    },
    add: {
      addButtonContent: '<center><i class="fas fa-plus text-success fa-2x"></i></center>',
      createButtonContent: '<i class="fas fa-save text-success m-r-10"></i>',
      cancelButtonContent: '<i class="fas fa-times fa-lg text-danger"></i>',
      confirmCreate: true
    },
    edit: {
      editButtonContent: '<i class="fas fas fa-edit text-info m-r-5"></i>',
      saveButtonContent: '<i class="fas fa-pencil-alt text-success m-r-10"></i>',
      cancelButtonContent: '<i class="fas fa-times fa-lg text-danger"></i>',
      confirmSave: true
    },
    delete: {
      deleteButtonContent: '<i class="fas fa-trash-alt text-danger"></i>',
      confirmDelete: true
    },
    attr: {
      class: 'table table-striped table-bordered table-hover'
    },
    defaultStyle: false
  };
  